<template>
  <div id="body delivery-page">
<div class="map-controls">

  <button
    class="toggle-btn detail-btn"
    @click="goBack"
    :title="$t('back')"
  >
    →
  </button>
</div>

    <!-- ======== Map ======== -->
    <MapComponent
      ref="mapRef"
      class="main-map"
      :center="mapCenter"
      :zoom="13"
      :markers="markers"
      map-type="neshanVectorNight"
      height="100%"
      width="100%"
    />

    <!-- CENTER MARKER -->
    <div class="center-marker">📍</div>


    <!-- ======== Bottom Card ======== -->
    <div class="bottom-panel">

      <div class="card shadow-lg delivery-card">
        <div class="card-body">

          <!-- sender address -->
          <div class="mb-3">
            <input
              v-model="senderAddress"
              placeholder="آدرس فرستنده"
              type="text"
              class="form-control address-input"
            />
          </div>

          <!-- delivery types -->
          <div class="delivery-types">

            <div
              class="delivery-option"
              :class="{selected: deliveryType==='motor'}"
              @click="deliveryType='motor'"
            >
              <div class="icon">🏍</div>
              <div class="label">موتور</div>
            </div>

            <div
              class="delivery-option"
              :class="{selected: deliveryType==='truck'}"
              @click="deliveryType='truck'"
            >
              <div class="icon">🚚</div>
              <div class="label">کامیون</div>
            </div>

            <div
              class="delivery-option"
              :class="{selected: deliveryType==='bike'}"
              @click="deliveryType='bike'"
            >
              <div class="icon">🚲</div>
              <div class="label">دوچرخه</div>
            </div>

          </div>

          <!-- actions -->
          <div class="actions">

            <button
              v-if="step==='sender'"
              class="btn action-btn primary"
              @click="confirmSenderLocation"
            >
              ثبت محل فرستنده
            </button>

            <button
              v-if="step==='receiver'"
              class="btn action-btn primary"
              @click="confirmReceiverLocation"
            >
              ثبت محل گیرنده
            </button>

            <button
              v-if="step==='done'"
              class="btn action-btn secondary"
              @click="editSender"
            >
              ویرایش فرستنده
            </button>

            <button
              v-if="step==='done'"
              class="btn action-btn secondary"
              @click="editReceiver"
            >
              ویرایش گیرنده
            </button>

            <button
              v-if="step==='done'"
              class="btn action-btn primary"
              @click="showFinalModal = true"
            >
              ثبت نهایی سفارش
            </button>

          </div>

        </div>
      </div>

    </div>


    <!-- ======== Sender Modal ======== -->
    <div v-if="showSenderModal" @save="saveSenderDetails" class="modal-mask">

      <div class="modal-box">

        <div class="modal-header primary">
          جزئیات فرستنده
          <button @click="showSenderModal=false">✖</button>
        </div>

        <form @submit.prevent="saveSenderDetails">

          <div class="modal-body">

            <label>نام</label>
            <input v-model="senderDetails.name" class="form-control" required />

            <label>شماره موبایل</label>
            <input v-model="senderDetails.phone" class="form-control" required />

            <label>آدرس دقیق</label>
            <input v-model="senderDetails.address" class="form-control" required />

          </div>

          <div class="modal-footer">

            <button type="button" class="btn btn-light" @click="showSenderModal=false">
              انصراف
            </button>

            <button type="submit" class="btn btn-success">
              ادامه
            </button>

          </div>

        </form>

      </div>

    </div>


    <!-- ======== Receiver Modal ======== -->
    <div v-if="showReceiverModal" @save="saveReceiverDetails" class="modal-mask">

      <div class="modal-box">

        <div class="modal-header success">
          جزئیات گیرنده
          <button @click="showReceiverModal=false">✖</button>
        </div>

        <form @submit.prevent="saveReceiverDetails">

          <div class="modal-body">

            <label>نام</label>
            <input v-model="receiverDetails.name" class="form-control" required />

            <label>شماره موبایل</label>
            <input v-model="receiverDetails.phone" class="form-control" required />

            <label>آدرس دقیق</label>
            <input v-model="receiverDetails.address" class="form-control" required />

          </div>

          <div class="modal-footer">

            <button type="button" class="btn btn-light" @click="showReceiverModal=false">
              انصراف
            </button>

            <button type="submit" class="btn btn-success">
              ثبت سفارش
            </button>

          </div>

        </form>

      </div>

    </div>

    <!-- ======== Final Modal ======== -->
    <div v-if="showFinalModal" class="modal-overlay">

      <div class="final-modal">

        <h5 class="mb-3">تایید نهایی سفارش</h5>

        <!-- Sender -->
        <div class="summary-item">
          <div>
            <strong>فرستنده</strong>
            <div class="text-muted small">
              {{ senderDetails.address }}
            </div>
          </div>

          <button class="btn btn-sm btn-light" @click="editSender">
            ویرایش
          </button>
        </div>

        <!-- Receiver -->
        <div class="summary-item">
          <div>
            <strong>گیرنده</strong>
            <div class="text-muted small">
              {{ receiverDetails.address }}
            </div>
          </div>

          <button class="btn btn-sm btn-light" @click="editReceiver">
            ویرایش
          </button>
        </div>

        <!-- Delivery Type -->
        <div class="summary-item">
          <div>
            <strong>نوع ارسال</strong>
            <div class="text-muted small">
              {{ deliveryType }}
            </div>
          </div>
        </div>

        <!-- Payment -->
        <div class="mb-3">
          <label class="form-label">روش پرداخت</label>

          <select v-model="paymentType" class="form-select">
            <option value="online">پرداخت آنلاین</option>
            <option value="sender">فرستنده پرداخت کند</option>
            <option value="receiver">گیرنده پرداخت کند</option>
          </select>
        </div>

        <!-- Stop time -->
        <div class="mb-3">
          <label class="form-label">مدت توقف در مقصد</label>

          <input
            type="number"
            v-model="stopMinutes"
            class="form-control"
            placeholder="دقیقه"
          />
        </div>

        <!-- Actions -->
        <div class="modal-actions">

          <button
            class="btn btn-light"
            @click="showFinalModal=false"
          >
            انصراف
          </button>

          <button
            class="btn btn-primary"
            @click="submitDelivery"
          >
            ثبت سفارش
          </button>

        </div>

      </div>

    </div>

    <!-- ======== Searching Toast ======== -->
    <div v-if="searching" class="search-toast">

      <span>در حال جستجوی راننده...</span>

      <div class="spinner-border spinner-border-sm"></div>

    </div>

  </div>
</template>

<script setup>
import { ref, onMounted } from "vue"
import MapComponent from "@/components/MapComponent.vue"
import { NESHAN_API_KEY } from "@/services/api"
import nmp from "@neshan-maps-platform/mapbox-gl"
import { deliveryService } from "@/services/api"
import { useRouter } from 'vue-router'

const router = useRouter()
const mapRef = ref(null)

const step = ref("sender")
const senderLocation = ref(null)
const receiverLocation = ref(null)
const senderMarker = ref(null)
const receiverMarker = ref(null)
const showSenderModal = ref(false)
const showReceiverModal = ref(false)
const deliveryType = ref('motor')
const routeLayerId = "delivery-route"

const senderDetails = ref({
    name: "",
    phone: "",
    address: ""
})

const receiverDetails = ref({
    name: "",
    phone: "",
    address: ""
})

const showFinalModal = ref(false)
const paymentType = ref("online")
const stopMinutes = ref(0)
const submitting = ref(false)

// Load customer info on mount
onMounted(async () => {
    try {
        const user = JSON.parse(localStorage.getItem('user') || '{}')
        senderDetails.value.name = `${user.first_name || ''} ${user.last_name || ''}`.trim()
        senderDetails.value.phone = user.phone_number || ''
    } catch (error) {
        console.error("Error loading customer info:", error)
    }
})

function getMap() {
    return mapRef.value?.getMap() || null
}

function getCenter() {
    return mapRef.value?.getCenter?.() || null
}

function confirmSenderLocation() {
    const center = getCenter()
    if (!center) {
        alert("لطفاً ابتدا موقعیت فرستنده را روی نقشه مشخص کنید")
        return
    }
    senderLocation.value = center
    showSenderModal.value = true
}

function saveSenderDetails() {
    showSenderModal.value = false
    addSenderMarker()
    step.value = "receiver"
}

function addSenderMarker() {
    const map = getMap()
    if (!map || !senderLocation.value) return
    
    if (senderMarker.value) senderMarker.value.remove()
    
    senderMarker.value = new nmp.Marker({ color: "green" })
        .setLngLat([senderLocation.value.lng, senderLocation.value.lat])
        .addTo(map)
}

function confirmReceiverLocation() {
    const center = getCenter()
    if (!center) {
        alert("لطفاً ابتدا موقعیت گیرنده را روی نقشه مشخص کنید")
        return
    }
    receiverLocation.value = center
    showReceiverModal.value = true
}

async function saveReceiverDetails() {
    showReceiverModal.value = false
    addReceiverMarker()
    step.value = "done"
    await createRoute()
}

function addReceiverMarker() {
    const map = getMap()
    if (!map || !receiverLocation.value) return
    
    if (receiverMarker.value) receiverMarker.value.remove()
    
    receiverMarker.value = new nmp.Marker({ color: "red" })
        .setLngLat([receiverLocation.value.lng, receiverLocation.value.lat])
        .addTo(map)
}

async function createRoute() {
    if (!senderLocation.value || !receiverLocation.value) return
    
    const origin = `${senderLocation.value.lat},${senderLocation.value.lng}`
    const destination = `${receiverLocation.value.lat},${receiverLocation.value.lng}`
    const url = `https://api.neshan.org/v4/direction?type=car&origin=${origin}&destination=${destination}`
    
    try {
        const response = await fetch(url, {
            headers: { "Api-Key": NESHAN_API_KEY }
        })
        const data = await response.json()
        const encoded = data.routes[0].overview_polyline.points
        drawRoute(encoded)
    } catch (err) {
        console.error("Route error:", err)
    }
}

function decodePolyline(str, precision = 5) {
    let index = 0, lat = 0, lng = 0, coordinates = []
    const factor = Math.pow(10, precision)
    
    while (index < str.length) {
        let b, shift = 0, result = 0
        do {
            b = str.charCodeAt(index++) - 63
            result |= (b & 0x1f) << shift
            shift += 5
        } while (b >= 0x20)
        
        const deltaLat = ((result & 1) ? ~(result >> 1) : (result >> 1))
        lat += deltaLat
        
        shift = 0
        result = 0
        do {
            b = str.charCodeAt(index++) - 63
            result |= (b & 0x1f) << shift
            shift += 5
        } while (b >= 0x20)
        
        const deltaLng = ((result & 1) ? ~(result >> 1) : (result >> 1))
        lng += deltaLng
        
        coordinates.push([lng / factor, lat / factor])
    }
    
    return coordinates
}

function drawRoute(encoded) {
    const map = getMap()
    if (!map) return
    
    const coords = decodePolyline(encoded)
    
    if (map.getSource(routeLayerId)) {
        map.removeLayer(routeLayerId)
        map.removeSource(routeLayerId)
    }
    
    map.addSource(routeLayerId, {
        type: "geojson",
        data: {
            type: "Feature",
            geometry: {
                type: "LineString",
                coordinates: coords
            }
        }
    })
    
    map.addLayer({
        id: routeLayerId,
        type: "line",
        source: routeLayerId,
        layout: {
            "line-cap": "round",
            "line-join": "round"
        },
        paint: {
            "line-color": "#2b7cff",
            "line-width": 6
        }
    })
}

function removeRoute() {
    const map = getMap()
    if (!map) return
    
    if (map.getSource(routeLayerId)) {
        map.removeLayer(routeLayerId)
        map.removeSource(routeLayerId)
    }
}

function editSender() {
    step.value = "sender"
    if (senderMarker.value) senderMarker.value.remove()
    removeRoute()
}

function editReceiver() {
    step.value = "receiver"
    if (receiverMarker.value) receiverMarker.value.remove()
    removeRoute()
}

function goBack(){
  router.push('/select-role')
}

async function submitDelivery() {
    submitting.value = true
    
    try {
        const payload = {
            senderLocation: {
                lat: senderLocation.value.lat,
                lng: senderLocation.value.lng,
                address: senderDetails.value.address
            },
            receiverLocation: {
                lat: receiverLocation.value.lat,
                lng: receiverLocation.value.lng,
                address: receiverDetails.value.address
            },
            senderDetails: senderDetails.value,
            receiverDetails: receiverDetails.value,
            deliveryType: deliveryType.value,
            paymentType: paymentType.value,
            stopMinutes: stopMinutes.value
        }
        
        const response = await deliveryService.createDelivery(payload)
        
        if (response.data.success) {
            alert("سفارش با موفقیت ثبت شد و به رانندگان نزدیک ارسال شد ✅")
            showFinalModal.value = false
            
            // Reset form
            setTimeout(() => {
                router.push('/customer/deliveries')
            }, 2000)
        }
    } catch (error) {
        console.error("Error submitting delivery:", error)
        alert("خطا در ثبت سفارش. لطفاً دوباره تلاش کنید.")
    } finally {
        submitting.value = false
    }
}
</script>

<style scoped>

#delivery-page{
height:100vh;
width:100%;
position:relative;
direction:rtl;
overflow:hidden;
}

.main-map{
position:absolute;
inset:0;
}

/* center marker */

.center-marker{
position:absolute;
top:50%;
left:50%;
transform:translate(-50%,-100%);
font-size:40px;
pointer-events:none;
z-index:10;
}

/* bottom card */

.bottom-panel{
position:absolute;
bottom:0;
width:100%;
display:flex;
justify-content:center;
padding:16px;
}

.delivery-card{
width:420px;
border-radius:20px;
}

/* delivery buttons */

.delivery-types{
display:flex;
justify-content:space-between;
gap:10px;
}

.delivery-btn{
flex:1;
border:1px solid #ddd;
background:white;
}

.delivery-btn.active{
background:#0d6efd;
color:white;
}

.delivery-btn.truck.active{
background:#f59e0b;
}

.delivery-btn.bike.active{
background:#16a34a;
}

/* modal */

.modal-mask{
position:fixed;
inset:0;
background:rgba(0,0,0,.55);
display:flex;
align-items:center;
justify-content:center;
z-index:20;
}

.modal-box{
width:420px;
background:white;
border-radius:14px;
overflow:hidden;
}

.modal-header{
padding:14px;
font-weight:600;
display:flex;
justify-content:space-between;
}

.modal-header.primary{
background:#0d6efd;
color:white;
}

.modal-header.success{
background:#16a34a;
color:white;
}

.modal-body{
padding:16px;
display:flex;
flex-direction:column;
gap:10px;
}

.modal-footer{
padding:12px;
display:flex;
justify-content:space-between;
}

/* searching */

.search-toast{
position:absolute;
bottom:20px;
left:50%;
transform:translateX(-50%);
background:#f59e0b;
color:white;
padding:12px 18px;
border-radius:10px;
display:flex;
align-items:center;
gap:10px;
font-weight:500;
z-index:15;
}
.delivery-card{
  border-radius:18px;
}

.address-input{
  border-radius:12px;
  padding:12px;
  font-size:14px;
}

.delivery-types{
  display:flex;
  justify-content:space-between;
  gap:10px;
  margin-bottom:16px;
}

.delivery-option{
  flex:1;
  background:#f8f9fa;
  border-radius:14px;
  padding:12px;
  text-align:center;
  cursor:pointer;
  transition:all .2s ease;
  border:2px solid transparent;
}

.delivery-option:hover{
  background:#eef3ff;
}

.delivery-option .icon{
  font-size:22px;
}

.delivery-option .label{
  font-size:13px;
  margin-top:4px;
}

.delivery-option.selected{
  background:#eef3ff;
  border-color:#4a6cf7;
  color:#4a6cf7;
  font-weight:600;
}

.actions{
  display:flex;
  flex-direction:column;
  gap:8px;
}

.action-btn{
  width:100%;
  border-radius:12px;
  padding:10px;
  font-size:14px;
}

.action-btn.primary{
  background:#4a6cf7;
  color:white;
}

.action-btn.secondary{
  background:#f1f3f5;
}

.modal-overlay{
  position:fixed;
  inset:0;
  background:rgba(0,0,0,0.4);
  display:flex;
  align-items:center;
  justify-content:center;
  z-index:2000;
}

.final-modal{
  background:white;
  border-radius:16px;
  padding:20px;
  width:350px;
  max-width:90%;
}

.summary-item{
  display:flex;
  justify-content:space-between;
  align-items:center;
  margin-bottom:12px;
}

.modal-actions{
  display:flex;
  justify-content:flex-end;
  gap:10px;
}

.form-label {
  color: var(--text);
}
.detail-btn{
  top:20px;
  right:20px;
}
.toggle-btn{
  position:absolute;
  z-index:20;
  background:white;
  border:none;
  padding:8px 12px;
  border-radius:10px;
  box-shadow:0 3px 10px rgba(0,0,0,0.2);
}
.main-map {
  position: absolute;
  inset: 0;
}

.map-controls {
  position: absolute;
  top: 30px;
  left: 0;
  right: 0;
  z-index: 20;
  display: flex;
  justify-content: flex-start;
  padding: 0 20px;
  gap: 12px;
  pointer-events: none; /* Allow clicking through container */
}

.map-controls > * {
  pointer-events: auto; /* Make buttons clickable */
}

.detail-btn {
  background: white;
  border: none;
  padding: 8px 12px;
  border-radius: 10px;
  box-shadow: 0 3px 10px rgba(0,0,0,0.2);
  cursor: pointer;
  font-size: 18px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* If search box is in MapComponent, adjust its position */
.map-search {
  position: relative; /* Change from absolute */
  transform: none;
  left: auto;
  top: auto;
  width: 300px; /* Slightly smaller to not overlap with button */
}

/* Or if you want to keep search box absolute, adjust its left position */
.map-search {
  position: absolute;
  top: 10px;
  left: 80px; /* Move to the right, making space for back button */
  transform: none;
  z-index: 20;
  width: 350px;
}
</style>
